<template>
  <section class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.path"></router-view>
    </keep-alive>
    <transition name="fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive" :key="$route.path"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>

<style scoped>
/* 在顶部导航模式下，让内容占满整个屏幕 */
.main-container.full-width {
  padding: 0;
}

.main-container.full-width .app-main {
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue